/** @flow */
import {
  GetSupplierClosedReferrals,
  GetSupplierClosedReferralsSuccess,
  GetSupplierClosedReferralsError,
  GetSupplierClosedReferralsStatusesSuccess,
  GetSupplierClosedReferralsStatusesError,
  //RTW
  ToggleRTWReferralDetailsModal,
  GetRTWReferralDetails,
  GetRTWReferralDetailsSuccess,
  GetRTWReferralDetailsError,
  //Log
  ToggleLogReferralDetailsModal,
  SubmitLogReferralDataSuccess,
  GetLogReferralDetails,
  SubmitLogReferralData,
  GetLogReferralDetailsSuccess,
  GetLogReferralDetailsError,
  SetReferralCommonData,
  //Status
  ToggleStatusReferralDetailsModal,
} from "@modules/reporting/constants/actions";
import * as reducers from "./reducers";
import initialState from "./state";
import type { ReferralTrackerState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: ReferralTrackerState = initialState, action: *): ReferralTrackerState => {
  const act = {
    // Active Referrals
    // Closed Referrals
    [GetSupplierClosedReferrals]: reducers.setLoading,
    [GetSupplierClosedReferralsSuccess]: reducers.onGetSupplierClosedReferralsSuccess,
    [GetSupplierClosedReferralsError]: reducers.onGetSupplierClosedReferralsError,
    // Closed Referrals Statuses
    [GetSupplierClosedReferralsStatusesSuccess]:
      reducers.onGetSupplierClosedReferralsStatusesSuccess,
    [GetSupplierClosedReferralsStatusesError]: reducers.onGetSupplierClosedReferralsStatusesError,
    // RTW
    [GetRTWReferralDetails]: reducers.setLoading,
    [GetRTWReferralDetailsSuccess]: reducers.onGetRTWReferralDetailsSuccess,
    [GetRTWReferralDetailsError]: reducers.onGetRTWReferralDetailsError,
    [ToggleRTWReferralDetailsModal]: reducers.onToggleRTWReferralDetailsModal,
    // Log
    [GetLogReferralDetails]: reducers.setLoading,
    [GetLogReferralDetailsSuccess]: reducers.onGetLogReferralDetailsSuccess,
    [GetLogReferralDetailsError]: reducers.onGetLogReferralDetailsError,
    [SubmitLogReferralData]: reducers.setLoading,
    [SubmitLogReferralDataSuccess]: reducers.onSubmitLogReferralDataSuccess,
    [ToggleLogReferralDetailsModal]: reducers.onToggleLogReferralDetailsModal,
    [SetReferralCommonData]: reducers.onSetReferralCommonData,
    //Status
    [ToggleStatusReferralDetailsModal]: reducers.onToggleStatusReferralDetailsModal,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
